import { createContext } from "react";

import { noop } from "../../../utils";

export const ModalContext = createContext<{
  requestClose: () => void;
  afterClose?: () => void;
}>({
  requestClose: noop,
  afterClose: noop,
});
